/* eslint-disable */
import Popups from './popups';

const $ = jQuery.noConflict();


'use strict';
const SingleProduct = {

	// properties
	$domSliderBox: $('.js-single-product__slider-box'),
	$domTabsBlockWrap: $('.single-product__image-wrapper-holder'),
	$domTabsBlockBox: $('.single-product__image'),
	$domColorBtn: $('.single-product__color'),
	$domAddToCartBtn: $('.js-addtocart-btn'),
	$domAddToCartBtnText: $('.js-addtocart-btn_text'),
	$domAddToCartPrice: $('.js-addtocart-btn span'),
	$domAddToCartFeedback: $('.js-addtocart-feedback'),
	$domAddToCartLoader: $('.single-product__btn-loader'),
	classLoaderShow: 'cart-button-loader-show',
	classActive: 'is-active',
	classSelected: 'is-selected',
	classStop: 'stay',
	classFixed: 'fixed',
	classSpinner: 'show-spinner',
	$selectedSize: null,
	$selectedColor: null,
	$customOrderSelectColor: $('#js-custom-order-select-color'),
	$customOrderSelectCountry: $('#billing_country'),
	$colorOptions: $('.single-product__colors'),
	$customSizePrice: '',
	$customSizeValid: false,
	$customWeight: '',
	$domCustomSizeHolder: $('.single-product__different-size'),
	$domSelectCustomBtn: $('.single-product__different-size-btn'),
	$redoneCheckbox: false,
	$redonePrice: 0,
	$colorErrorHolder: $('.single-product__no-color-error_holder'),
	$customHeight: '',
	$customWidth: '',
	$customOrderSelectPreservation: $('.custom-order-preservation'),


	// initialize
	init: function() {
		if ($('body.single-product').length === 0) {
			return; // wrong page
		}
		this.isRedoneChecked();
		$('input[name="redone"]').on('click', function() {
			SingleProduct.isRedoneChecked();
		});
		$('#tab-description').insertAfter('.product_title');
		$('.wps_wgm_price').attr('placeholder', '');
		$('.wps_wgm_message').attr('placeholder', 'Happy Birthday!');
		$(document).ready(function () {
			$('.wps_wgm_price').val('');
			$('.wps_wgm_message').val('');
			$('.wps_uwgc_send_date').val('');
			$('.wps_uwgc_send_date').attr('placeholder', 'MM/DD/YYYY');
			setTimeout(() => {
				$('.wps_wgm_price').addClass('color-change');
				$('.wps_uwgc_send_date').addClass('color-change');
			}, 200);
		});
		$('.wps_uwgc_info').text('Recipient will receive the Gift Card on the selected date, within an hour of your scheduled time.');
		this.getCustomSizes();
		this.bindSelectSize();
		this.bindSelectColor();
		this.bindSpecialColorTooltip();
		this.bindAddToCart();
		this.updateForm();
		// this.bindCustomForm();
		this.preselectSizeFromURL();
		this.appendCustomOrderColors();
		this.handleSelectChange();
		this.addToCartGiftCard();
		$(document).ready(function() {
			function relocateTitle() {
				if ($(window).width() < 768) {
					$('.single-product__right-text__wrapper').prependTo('.single-product__left');
				} else {
					$('.single-product__right-text__wrapper').prependTo('.single-product__right');
				}
			}

			relocateTitle();
			$(window).resize(function() {
				relocateTitle();
			});
		});
		$('.custom-order-preservation').on('change', function() {
			SingleProduct.appendCustomOrderColors();
		});
	},

	GiftCardValidation: function() {
		let isValid = true;

		// Remove previous errors
		$('.gift-card-error').remove();

		// Selectors for fields
		const $price = $('.wps_wgm_price');
		const $from = $('.wps_wgm_from_name');
		const $message = $('.wps_wgm_message');
		const $recipientEmail = $('#wps_wgm_to_email');
		const $recipientName = $('#wps_wgm_to_name_optional');
		const $quantity = $('.input-text.qty.text');
		const $recipientNameDownload = $('#wps_wgm_to_download');

		// Helper for error
		function showError($el, msg) {
			$el.after('<div class="gift-card-error" style="color:red;font-size:12px;">' + msg + '</div>');
			isValid = false;
		}

		// Price: required, number
		// Get minimum price from the element with class 'wps_wgm_min_user_price'
		let minPrice = 0;
		const minPriceText = $('.wps_wgm_min_user_price').text();
		const minPriceMatch = minPriceText.match(/: ([\d.,]+)/);
		if (minPriceMatch && minPriceMatch[1]) {
			minPrice = parseFloat(minPriceMatch[1].replace(',', '.'));
		}

		const priceVal = parseFloat($price.val());
		if (!$price.val() || isNaN(priceVal) || priceVal <= 0) {
			showError($price, 'Please enter a valid price.');
		} else if (minPrice && priceVal < minPrice) {
			showError($price, '');
		}

		// From: required
		if (!$from.val() || !$from.val().trim()) {
			showError($from, 'Please enter your name.');
		}

		// Gift message: required
		if (!$message.val() || !$message.val().trim()) {
			showError($message, 'Please enter a gift message.');
		}

		// Recipient email: required, valid email
		const emailVal = $recipientEmail.val();
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if ($recipientEmail.is(':visible')) {
			if (!emailVal || !emailRegex.test(emailVal)) {
				showError($recipientEmail, 'Please enter a valid email address.');
			}
		}

		// Recipient name: required (only validate the visible one)
		if ($recipientName.is(':visible')) {
			if (!$recipientName.val() || !$recipientName.val().trim()) {
				showError($recipientName, 'Please enter recipient\'s name.');
			}
		} else if ($recipientNameDownload.is(':visible')) {
			if (!$recipientNameDownload.val() || !$recipientNameDownload.val().trim()) {
				showError($recipientNameDownload, 'Please enter recipient\'s name.');
			}
		}

		// Quantity: required, number
		if (!$quantity.val() || isNaN($quantity.val()) || parseInt($quantity.val()) <= 0) {
			showError($quantity, 'Please enter a valid quantity.');
		}

		// Always scroll to the top of the form
		// Scroll to the top of the form only if there are errors
		if (!isValid) {
			const $form = $('.wps_wgm_price').closest('form');
			if ($form.length) {
				$('html, body').animate({
					scrollTop: $form.offset().top - 100
				}, 500);
			}
		}

		return isValid;
	},

	addToCartGiftCard: function() {
		const addToCartBtn = document.querySelector('.single_add_to_cart_button');
		if (!addToCartBtn) return;

		addToCartBtn.addEventListener('click', function(e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			if (!SingleProduct.GiftCardValidation()) {
				// If validation fails, do not proceed
				return;
			}

			// If validation passes, manually submit the form
			const form = document.querySelector('form.cart');
			if (form) {
				form.submit();
			}

			// TODO - Uncomment the AJAX request when ready if client wants to use AJAX for adding gift cards to cart
			// $.post({
			// 	url: window.fwsLocalized.ajaxUrl,
			// 	dataType: 'JSON',
			// 	data: {
			// 		action: 'fws-add-to-cart-gift-card',
			// 		productId: $('main .single-product').data('product-id'),
			// 		_wpnonce: window.fwsLocalized.nonce,
			// 	},
			// 	success: (response) => {
			// 		if (response && response.success) {
			// 			SingleProduct.onAddToCartSuccess(response);
			// 		} else {
			// 			SingleProduct.onAddToCartFailure(response);
			// 		}
			// 	},
			// 	error: (jqXHR, textStatus) => {
			// 		let message = 'Something  went wrong.';
			// 		if (jqXHR.responseText === '0' && jqXHR.status === 400) message = 'Something  went wrong: unknown action.';
			// 		SingleProduct.onAddToCartFailure({error: message});
			// 	},
			// 	complete: () => {
			// 		SingleProduct.$domAddToCartBtn.toggleClass(SingleProduct.classSpinner, false);
			// 		SingleProduct.$domAddToCartLoader.removeClass(SingleProduct.classLoaderShow);
			// 	}
			// });
		});
	},

	isRedoneChecked: function() {
		const redoneCheckbox = $('input[name="redone"]');

		// Initialize the global variables based on the checkbox state
		SingleProduct.$redoneCheckbox = redoneCheckbox.is(':checked');
		SingleProduct.$redonePrice = redoneCheckbox.is(':checked') ? parseFloat(redoneCheckbox.val()) : 0;
		SingleProduct.updateForm();
	},


	// pre-select size if  it exist in url
	preselectSizeFromURL: function() {
		const urlSearchParams = new URLSearchParams(location.search);
		const searchedSize = urlSearchParams.get('attribute_pa_sizes');
		SingleProduct.$domSliderBox.parent().find('[data-slug="' + searchedSize + '"]').trigger('click');
	},


	// handle click on frame size
	bindSelectSize: function() {
		$(document).on('click', '.js-custom-size-remover', function(e) {
			$('.single-product__no-size-error_holder').text('');
			e.preventDefault();
			SingleProduct.clearCustomSizes();
			SingleProduct.$domSelectCustomBtn.text("Calculate");
			$('.js-custom-size-remover-holder').remove();
			SingleProduct.$selectedSize = '';
			SingleProduct.$customSizePrice = '';
			SingleProduct.updateForm();
		});
		SingleProduct.$domSliderBox.each(function(e, el) {
			$(el).on('click', function() {
				$('.single-product__no-size-error_holder').text('');
				SingleProduct.$selectedSize = $(this).parent().hasClass(SingleProduct.classActive) ? null : $(this);
				SingleProduct.updateForm();
				SingleProduct.clearCustomSizes();
			});
		});

		//On inserted values for height and width calculate the price from the custom table in admin and also get its custom weight.
		$('#calculate_price_button').on('click', function(e) {
			// SingleProduct.$domAddToCartBtn.addClass(SingleProduct.classActive);
			SingleProduct.clearErrors();
			// SingleProduct.disableInputs();
			$('.single-product__different-size-error_holder').text('');
			e.preventDefault();
			$('.single-product__different-size-btn').toggleClass('cart-button-loader-show', true);
			// SingleProduct.$domAddToCartBtn.toggleClass(SingleProduct.classActive, false);
			SingleProduct.$domSliderBox.parent().removeClass(SingleProduct.classActive);

			// Get the width and height input values
			let width = parseFloat($('#size-width').val());
			let height = parseFloat($('#size-length').val());

			// Calculate the square inches
			let square_inches = width * height;

			// Define maximum allowed dimensions
			const maxWidth = SingleProduct.$customWidth ? SingleProduct.$customWidth : 30;
			const maxHeight = SingleProduct.$customHeight ? SingleProduct.$customHeight : 40;

			// Check if the values are valid
			if (isNaN(square_inches) || square_inches <= 0) {
				$('.single-product__different-size-error_holder').text('Please enter valid width and height values.');
				$('.single-product__different-size-btn').toggleClass('cart-button-loader-show', false);
				return;
			}

			// Send AJAX request to get the price
			$.ajax({
				url: window.fwsLocalized.ajaxUrl, // WordPress's AJAX URL
				method: 'POST',
				data: {
					action: 'get_puzzle_price',
					square_inches: square_inches
				},
				success: function(response) {
					if (response.success && ((width <= maxWidth && height <= maxHeight) || (width <= maxHeight && height <= maxWidth))) {
						SingleProduct.clearErrors();
						SingleProduct.resetAddToCart();
						// SingleProduct.$domAddToCartBtn.addClass(SingleProduct.classActive);
						SingleProduct.$customSizePrice = response.data.total_price;
						SingleProduct.$selectedSize = '';
						SingleProduct.$domAddToCartPrice.text('- $' + response.data.total_price);
						SingleProduct.$domSelectCustomBtn.text('$' + response.data.total_price);
						SingleProduct.$domCustomSizeHolder.append('<span class="js-custom-size-remover-holder"><a class="js-custom-size-remover" href="#"></a></span>');
						SingleProduct.updateForm();
						$('.single-product__different-size-btn').toggleClass('cart-button-loader-show', false);
						SingleProduct.$customWeight = response.data.custom_weight;
					} else {
						SingleProduct.$selectedSize = '';
						$('.js-addtocart-btn_text').text('CUSTOM ORDER FORM');
						$('.js-addtocart-btn').addClass('js-single-product__slider-after-link');
						$('.single-product__different-size-error_holder').html('Please fill in the <span class="js-single-product__slider-after-link">custom order</span> form for this size.');
						SingleProduct.updateForm();
						SingleProduct.$domSelectCustomBtn.text("Calculate");
						$('.single-product__btn-price').text('');
						$('.single-product__different-size-btn').toggleClass('cart-button-loader-show', false);
						$('html, body').animate({
							scrollTop: $('.js-addtocart-btn').offset().top - ($(window).height() / 2) + ($('.js-addtocart-btn').outerHeight() / 2)
						}, 600);
					}
				},
				error: function() {
					alert('An error occurred while calculating the price.');
				},
				complete: function() {
					SingleProduct.$domAddToCartBtn.addClass(SingleProduct.classActive);
					SingleProduct.enableInputs();
				}
			});
		});

		// While user inputs the value of height/width add at the end of the value inch symbol.
		$('#size-length, #size-width').on('input', function(event) {
			SingleProduct.$domAddToCartBtn.removeClass(SingleProduct.classActive);
			$('.single-product__different-size-error_holder').text('');
			// Get the current value
			let value = $(this).val();

			// Remove all non-numeric characters except the decimal point
			value = value.replace(/[^\d.]/g, '');

			// Ensure only one decimal point exists
			if ((value.match(/\./g) || []).length > 1) {
				value = value.replace(/\.+$/, ''); // Remove additional decimal points
			}

			// If the Backspace key was pressed
			if (event.originalEvent.inputType === 'deleteContentBackward') {
				// Delete last character if value exists and is long enough
				if (value && value.length > 1) {
					value = value.slice(0, -1);
				} else if (value.length === 1) {
					value = "";
				}
				// Append the inch symbol if value is not empty
				if (value) {
					value += '"';
				}
			} else {
				// If the value is not empty, ensure it ends with an inch symbol
				if (value && !value.endsWith('"')) {
					value += '"';
				}
			}

			// Update the input field with the modified value
			$(this).val(value);
		});

		$('#size-length, #size-width').on('blur', function() {
			setTimeout(SingleProduct.checkAndClickButton, 100);
		});

		$(document).on('click', '.js-single-product__slider-after-link', function(e) {
			e.preventDefault();
			$('.js-single-product__slider-upper-link').click();
		});
	},


	// handle click on color buttons
	bindSelectColor: function() {
		SingleProduct.$domColorBtn.on('click', function(e) {
			$('.single-product__no-color-error_holder').text('');
			e.preventDefault();
			SingleProduct.$selectedColor = $(this);
			SingleProduct.updateForm();
		});
	},


	// update visibility of form elements
	updateForm: function() {
		// update size buttons
		const selectedSlug = SingleProduct.$selectedSize ? SingleProduct.$selectedSize.data('slug') : null;
		SingleProduct.$domSliderBox.parent().parent().children().each(function() {
			const thisSlug = $(this).find('.js-single-product__slider-box').data('slug');
			$(this).toggleClass(SingleProduct.classActive, thisSlug === selectedSlug);
		});
		// update color buttons
		const selectedColor = SingleProduct.$selectedColor ? SingleProduct.$selectedColor.data('color-id') : null;
		SingleProduct.$domColorBtn.each(function() {
			$(this).toggleClass(SingleProduct.classActive, $(this).data('color-id') === selectedColor);
		});
		// update frame image
		const index = SingleProduct.$selectedColor ? SingleProduct.$selectedColor.index() : 0;
		// if (!SingleProduct.$domTabsBlockBox.eq(index).is(':visible')) {
		// 	SingleProduct.$domTabsBlockBox.hide();
		// 	SingleProduct.$domTabsBlockBox.eq(index).fadeIn('slow');
		// 	if (window.innerWidth < 768) {
		// 		$('html, body').animate({
		// 			scrollTop: SingleProduct.$domTabsBlockWrap.offset().top - 150
		// 		}, 1000);
		// 	}
		// }
		if (!SingleProduct.$domTabsBlockBox.eq(index).is(':visible')) {
			SingleProduct.$domTabsBlockBox.hide();
			SingleProduct.$domTabsBlockBox.eq(index).fadeIn('slow');

			if (window.innerWidth < 768 && SingleProduct.$domTabsBlockWrap.length && typeof SingleProduct.$domTabsBlockWrap.offset() !== 'undefined') {
				$('html, body').animate({
					scrollTop: SingleProduct.$domTabsBlockWrap.offset().top - 150
				}, 1000);
			}
		}
		// check custom size fields
		const customLength = $('#size-length').val();
		const customWidth = $('#size-width').val();
		SingleProduct.$customSizeValid = parseFloat(customLength) > 0 && parseFloat(customWidth) > 0 && customLength && customWidth;

		// enable "add to cart" button
		const enableAddToCart = ((SingleProduct.$selectedSize !== null && SingleProduct.$selectedSize !== '') || SingleProduct.$customSizeValid || SingleProduct.$customSizePrice) ? true : false;
		let totalPrice = 0;
		if (SingleProduct.$customSizePrice && !SingleProduct.$selectedSize) {
			totalPrice = SingleProduct.$redoneCheckbox ? parseFloat(SingleProduct.$customSizePrice) + parseFloat(SingleProduct.$redonePrice) : SingleProduct.$customSizePrice;
			// update price in button
			SingleProduct.$domAddToCartPrice.text(SingleProduct.$customSizePrice ? '- $' + totalPrice : '');
		} else {
			let selectedPrice = SingleProduct.$selectedSize ? parseFloat(SingleProduct.$selectedSize.data('price')) || 0 : 0;
			totalPrice = SingleProduct.$redoneCheckbox ? selectedPrice + parseFloat(SingleProduct.$redonePrice || 0) : selectedPrice;
			// update price in button
			SingleProduct.$domAddToCartPrice.text(SingleProduct.$selectedSize ? '- $' + totalPrice : '');
		}
	},


	clearCustomSizes: function() {
		$('.single-product__different-size-error_holder').text('');
		$('#size-length, #size-width').val('');
		SingleProduct.$customWeight = '';
		SingleProduct.resetAddToCart();
	},


	// handle mouseover on special color button
	bindSpecialColorTooltip: function() {
		if (window.innerWidth < 1200) {
			$('.js-single-product__color--spec').on('click', function() {
				$('.js-single-product__color--spec-tooltip').addClass('is-visible');
				setTimeout(function() {
					$('.js-single-product__color--spec-tooltip').removeClass('is-visible');
				}, 8000);
			});
		}
	},


	// handle click on "add to cart" button
	bindAddToCart: function() {
		SingleProduct.$domAddToCartBtn.on('click', function() {
			SingleProduct.clearErrors();
			let $errorHolderColor = $('.single-product__no-color-error_holder');
			let $errorHolderSize = $('.single-product__no-size-error_holder');
			const customLength = $('#size-length').val();
			const customWidth = $('#size-width').val();
			SingleProduct.$customSizeValid = parseFloat(customLength) > 0 && parseFloat(customWidth) > 0 && customLength && customWidth;

			if (SingleProduct.$selectedColor === '' || SingleProduct.$selectedColor === null) {
				let productTitle = $('.single-product__title').text();
				let errorText = 'Please select frame color';

				if (productTitle.includes('Laminate')) {
					errorText = 'Please select edge color';
				}
				$errorHolderColor.text(errorText);
				SingleProduct.$domAddToCartLoader.removeClass(SingleProduct.classLoaderShow);

				// Check if the button text is not equal to 'CUSTOM ORDER FORM' (case insensitive)
				if (SingleProduct.$domAddToCartBtnText.text().toLowerCase() !== 'custom order form') {
					// Scroll to the error message smoothly
					$('html, body').animate({
						scrollTop: $errorHolderColor.offset().top - ($(window).height() / 2) + ($errorHolderColor.outerHeight() / 2)
					}, 500);
				}
			}

			if (!SingleProduct.$selectedSize && !SingleProduct.$customSizeValid) {
				$errorHolderSize.text('Please select size');
				if (!$errorHolderColor.text()) {
					// Scroll to the error message smoothly
					$('html, body').animate({
						scrollTop: $errorHolderSize.offset().top - ($(window).height() / 2) + ($errorHolderSize.outerHeight() / 2)
					}, 500);
				}
				SingleProduct.$domAddToCartLoader.removeClass(SingleProduct.classLoaderShow);
			}

			const stillWaitingForResponse = SingleProduct.$domAddToCartBtn.hasClass(SingleProduct.classSpinner);
			if ((!SingleProduct.$selectedSize && !SingleProduct.$customSizeValid) || (SingleProduct.$selectedSize === null && SingleProduct.$customSizePrice === null) || SingleProduct.$selectedColor === null || stillWaitingForResponse) {
				return;
			}
			// show spinner & clear feedback
			SingleProduct.$domAddToCartBtn.toggleClass(SingleProduct.classSpinner, true);
			SingleProduct.$domAddToCartLoader.addClass(SingleProduct.classLoaderShow);
			SingleProduct.$domAddToCartFeedback.empty();

			// Get the custom size values (width, height, etc.)
			const width = parseFloat($('#size-width').val());
			const height = parseFloat($('#size-length').val());
			const square_inches = width * height;

			let variationId = SingleProduct.$selectedSize ? SingleProduct.$selectedSize.data('variation-id') : SingleProduct.$domSliderBox.first().data('variation-id');
			let isSelectedSize = SingleProduct.$selectedSize ? 1 : '';
			let selectedSizePrice = SingleProduct.$selectedSize ? SingleProduct.$selectedSize.data('price') : '';
			let customPriceText = $('.single-product__btn-price').text();
			let match = customPriceText.match(/-?\d+/g);
			let customPrice = parseInt(match ? match.join('') : '0', 10);
			let productPrice = SingleProduct.$customSizePrice ? customPrice : selectedSizePrice;
			const isRedoneChecked = $('#redone').prop('checked');
			const redoneVal = isRedoneChecked ? $('#redone').val() : 0;

			// send request and test error messages
			if (productPrice && !SingleProduct.hasErrorText()) {
				$.post({
					url: window.fwsLocalized.ajaxUrl,
					dataType: 'JSON',
					data: {
						action: 'fws-add-to-cart',
						productId: $('main .single-product').data('product-id'),
						variationId: variationId,
						colorId: SingleProduct.$selectedColor.data('color-id'),
						square_inches: square_inches, // Pass custom size data
						custom_width: width,
						custom_height: height,
						isSelectedSize: isSelectedSize,
						productPrice: productPrice,
						productWeight: SingleProduct.$customWeight,
						redonePrice: redoneVal
					},
					success: (response) => {
						if (response && response.success) {
							SingleProduct.onAddToCartSuccess(response);
						} else {
							SingleProduct.onAddToCartFailure(response);
						}
					},
					error: (jqXHR, textStatus) => {
						let message = 'Something  went wrong.';
						if (jqXHR.responseText === '0' && jqXHR.status === 400) message = 'Something  went wrong: unknown action.';
						SingleProduct.onAddToCartFailure({error: message});
					},
					complete: () => {
						SingleProduct.$domAddToCartBtn.toggleClass(SingleProduct.classSpinner, false);
						SingleProduct.$domAddToCartLoader.removeClass(SingleProduct.classLoaderShow);
					}
				});
			} else {
				SingleProduct.$domAddToCartBtn.toggleClass(SingleProduct.classSpinner, false);
			}
		});
	},


	// handle success of adding to cart
	onAddToCartSuccess: function(response) {
		const width = parseFloat($('#size-width').val());
		const height = parseFloat($('#size-length').val());
		let size = $('.single-product__slider-box.is-active .single-product__slider-box-dimensions').text();
		let image = $('.single-product__image:visible img').attr('src');
		if (response.data.is_gift_card) {
			size = response.data.title ? response.data.title : 'Gift Card';
			image = $('.woocommerce-product-gallery__image img').attr('src');
		} else {
			if (width && height) {
				console.log(width, height);
				size = height + '“' + ' X ' + width + '“';
			}
		}

		// show popup notification

		const text = '<span class="cart-popup__box-text-product">' + size + '</span> has been added to cart!';
		Popups.addProductToCartPopup(image, text);
		// update count in cart-icon
		$('.js-header-cart-num').text(response.data.count);
		// unselect selectors
		SingleProduct.$selectedSize = null;
		SingleProduct.$selectedColor = null;
		SingleProduct.clearCustomSizes();
		$('#redone').prop('checked', false);
		SingleProduct.$redoneCheckbox = false;
		SingleProduct.$redonePrice = 0;
		SingleProduct.$domSelectCustomBtn.text("Calculate");
		SingleProduct.$customSizePrice = 0;
		$('.single-product__btn-price').text('');
		SingleProduct.updateForm();
	},


	// handle soft-failure of adding to cart
	onAddToCartFailure: function(response) {
		const html = '<span class="error">' + response.error + '</span>';
		SingleProduct.$domAddToCartFeedback.html(html);
	},


	// custom order form
	bindCustomForm: function() {
		const $fileInput = $('.file-input');
		const $droparea = $('.custom-form__input-d-and-d');
		// highlight drag area
		$fileInput.on('dragenter focus click', function() {
			$droparea.addClass('is-active');
		});
		// back to normal state
		$fileInput.on('dragleave blur drop', function() {
			$droparea.removeClass('is-active');
		});
		// change inner text
		$fileInput.on('change', function() {
			const filesCount = $(this)[0].files.length;
			const $textContainer = $('.custom-form__input-d-and-d-title');
			if (filesCount === 1) {
				// if single file is selected, show file name
				const fileName = $(this).val().split('\\').pop();
				$textContainer.text(fileName);
				$('.custom-form__input-d-and-d-subtitle').fadeOut();
				$('.custom-form__input-d-and-d-delete').fadeIn();
			} else {
				// otherwise show number of files
				$textContainer.text(filesCount + ' files selected');
				$('.custom-form__input-d-and-d-subtitle').fadeOut();
				$('.custom-form__input-d-and-d-delete').fadeIn();
			}
		});
		// remove file
		$('.custom-form__input-d-and-d-delete').on('click', function() {
			$('.file-input').val('');
			$('.custom-form__input-d-and-d-subtitle').fadeIn();
			$('.custom-form__input-d-and-d-title').text('Upload photos of the puzzle');
			$('.custom-form__input-d-and-d-delete').fadeOut();
		});
	},


	// Append new option to select
	appendOption: function(selector, value, text, color, special) {
		// If special option render different class
		if (special) {
			selector.append(`<option value="${value}"><span class="color-dot-spec">${text}</span></option>`);
		} else {
			selector.append(`<option value="${value}"><span class="color-dot" style="background-color: ${color};">${text}</span></option>`);
		}
	},

	// Format state
	customSelect2RowTemplate: function(state) {
		if (!state.id) {
			return state.text;
		}
		const colorClass = $(state.element).children().attr('class');
		if (colorClass === 'color-dot-spec') {
			const $state = $(
				'<span><span class="' + colorClass + '"></span> ' + state.text + '</span>'
			);

			return $state;
		}
		const $state = $(
			'<span><span class="' + colorClass + '" style="background-color: ' + $(state.element).children('.color-dot').css('background-color') + '"></span> ' + state.text + '</span>'
		);

		return $state;
	},

	// Append custom order color option
	appendCustomOrderColors: function() {
		const preservationType = $('.custom-order-preservation').val(); // Get selected value
		if (preservationType.toLowerCase() === 'laminating' || preservationType.toLowerCase() === 'framing') {
			let colorSelect = $('#js-custom-order-select-color').parent().parent().find('label');
			let colorLabelText = preservationType.toLowerCase() === 'laminating' ? 'Select edge color' : 'Select frame color';
			colorSelect.text(colorLabelText);
			$('#js-custom-order-select-color').prop('disabled', true);
			$.ajax({
				url: window.fwsLocalized.ajaxUrl, // Ensure this is correctly defined in your WordPress setup
				method: 'POST',
				data: {
					action: 'cf7_get_colors_ajax'
				},
				success: function(response) {
					if (response.success) {
						const colors = preservationType.toLowerCase() === 'laminating' ? response.data.laminating : response.data.framing;
						SingleProduct.updateColorOptions(colors);
					}
				},
				complete: function() {
					// Re-enable the select field after the AJAX is complete
					$('#js-custom-order-select-color').prop('disabled', false);
					$('#js-custom-order-select-color').parent().parent().find('.contact-us__form-wrap-label').removeClass('is-moved');
				}
			});
		} else {
			SingleProduct.$customOrderSelectColor.empty();
			SingleProduct.appendOption(SingleProduct.$customOrderSelectColor, '', '', '', false); // Placeholder option

			SingleProduct.$colorOptions.children('.single-product__color').each(function() {
				if ($(this).hasClass('js-single-product__color--spec')) {
					SingleProduct.appendOption(SingleProduct.$customOrderSelectColor, 'Choose for me', 'Choose for me', '', true);
					return;
				}
				const colorHex = $(this).css('background-color');
				const colorName = $(this).children('.single-product__color-title').text();
				SingleProduct.appendOption(SingleProduct.$customOrderSelectColor, colorName, colorName, colorHex, false);
			});
		}
	},

	updateColorOptions: function(colors) {
		SingleProduct.$customOrderSelectColor.empty();
		SingleProduct.appendOption(SingleProduct.$customOrderSelectColor, '', '', '', false);
		SingleProduct.appendOption(SingleProduct.$customOrderSelectColor, 'Choose for me', 'Choose for me', '', true);
		colors.forEach(color => {
			SingleProduct.appendOption(SingleProduct.$customOrderSelectColor, color.title, color.title, color.rgb, false);
		});
	},

	handleSelectChange: function() {
		SingleProduct.$customOrderSelectColor.on('change', function(e) {
			SingleProduct.clearFormErrors(e);
		});
		SingleProduct.$customOrderSelectPreservation.on('change', function(e) {
			SingleProduct.clearFormErrors(e);
		});
		SingleProduct.$customOrderSelectCountry.on('change', function(e) {
			SingleProduct.clearFormErrors(e);
		});
	},


	checkAndClickButton: function() {
		let lengthInput = $('#size-length');
		let widthInput = $('#size-width');
		if (lengthInput.val().trim() !== '' && widthInput.val().trim() !== '') {
			$('.single-product__different-size-btn').trigger('click'); // Click the button
		}
	},

	clearErrors: function() {
		let $errorHolderColor = $('.single-product__no-color-error_holder');
		let $errorHolderSize = $('.single-product__no-size-error_holder');
		let $errorHolderCustomSize = $('.single-product__different-size-error_holder');
		$errorHolderColor.text('');
		$errorHolderSize.text('');
		$errorHolderCustomSize.text('');
	},

	clearFormErrors: function(e) {
		const errorSpan = $(e.target).closest('.wpcf7-form-control-wrap').find('.wpcf7-not-valid-tip');
		const errorSelect = $(e.target).closest('.wpcf7-form-control-wrap').find('.wpcf7-select');
		if (errorSpan.length > 0) {
			errorSpan.remove();
		}
		if (errorSelect.length > 0) {
			errorSelect.removeClass('wpcf7-not-valid');
		}
	},

	disableInputs: function() {
		let widthInput = $('#size-width');
		let heightInput = $('#size-length');
		widthInput.prop('disabled', true);
		heightInput.prop('disabled', true);
	},

	enableInputs: function() {
		let widthInput = $('#size-width');
		let heightInput = $('#size-length');
		widthInput.prop('disabled', false);
		heightInput.prop('disabled', false);
	},

	resetAddToCart: function() {
		SingleProduct.$domAddToCartBtnText.text('ADD TO CART');
		SingleProduct.$domAddToCartBtn.removeClass('js-single-product__slider-after-link');
	},

	hasErrorText: function() {
		let errorHolderColor = $('.single-product__no-color-error_holder');
		let errorHolderSize = $('.single-product__no-size-error_holder');
		let errorHolderCustomSize = $('.single-product__different-size-error_holder');

		// Check if any of the elements contain text
		if (errorHolderColor.text().trim() !== '' || errorHolderSize.text().trim() !== '' || errorHolderCustomSize.text().trim() !== '') {
			return true;
		}

		return false; // No error text found
	},

	getAllColors: function() {
		$.ajax({
			url: window.fwsLocalized.ajaxUrl, // WordPress AJAX URL
			type: 'POST',
			data: {
				action: 'cf7_get_colors_ajax',
			},
			success: function(response) {
				console.log(response);
			},
			error: function() {
				console.log('Greska');
			}
		});
	},

	getCustomSizes: function() {
		const productTitle = $('.section-title.single-product__title').text().trim();
		$.ajax({
			url: window.fwsLocalized.ajaxUrl, // WordPress's AJAX URL
			method: 'POST',
			data: {
				action: 'get_puzzle_sizes'
			},
			success: function(response) {
				if (response.success) {
					let customSize = productTitle.includes('Laminate') ? response.data.laminating_sizes : response.data.framing_sizes;
					SingleProduct.$customHeight = customSize.height;
					SingleProduct.$customWidth = customSize.width;
				} else {
				}
			},
			error: function() {
				alert('An error occurred while calculating the price.');
			},
		});
	}
};

export default SingleProduct;

